import styled from 'styled-components';

import { styles } from '../../consts';

const { fontMontserrat, paymentColor } = styles;

const GPayDetailsContainer = styled.div`
  display: flex;
  justify-content: left;
  font-family: ${fontMontserrat};
  font-size: 0.8rem;
  font-weight: 300;
  font-style: normal;
  color: ${paymentColor};
`;

export default GPayDetailsContainer;
